import FloatSelect from './float_select';

export default class FloatCountry extends FloatSelect {
  static get properties() {
    return {
      ...super.properties,
      countries: { type: Array },
    };
  }

  constructor() {
    super();
    this.countries = [];
    this.autocomplete = "country"
  }

  firstUpdated() {
    super.firstUpdated();

    if (!this.select.value) return;

    this.emitCountryChange();
  }

  handleChange() {
    super.handleChange();
    this.emitCountryChange();
  }

  emitCountryChange() {
    this.emitEvent('float-country:change', {
      detail: {
        country: this.select.value,
      },
      bubbles: true,
    });
  }
}

window.customElements.get('float-country') ||
  window.customElements.define('float-country', FloatCountry);
